export class SaveDialogData {
  constructor(
    public title: string,
    public message: string,
    public confirmText: string,
    public confirmNoActionText: string,
    public cancelText: string
  ) {}
}
